import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {  HomeComponent } from './components/pages/Home/home.component';
import { AboutComponent } from './components/pages/about/about.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { WhyImonitorComponent } from './components/pages/why-imonitor/why-imonitor/why-imonitor.component';
import { FeautersComponent } from './components/pages/feauters/feauters.component';
import { IndustriesComponent } from './components/pages/industries/industries.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';

const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' }, // Redirect root to home
    { path: 'home', component: HomeComponent },
    // Handle www and non-www redirects
    { path: 'about', component: AboutComponent, data: { title: 'About IMonitor - Smart Digital Inspection Solution' } },
    { path: 'why-imonitor', component: WhyImonitorComponent, data: { title: 'Why Choose IMonitor | Digital Inspection Platform' } },
    { path: 'faq', component: FaqComponent, data: { title: 'Frequently Asked Questions - IMonitor Support' } },
    { path: 'contact', component: ContactComponent, data: { title: 'Contact IMonitor - Get in Touch With Our Team' } },
    { path: 'feauters', component: FeautersComponent, data: { title: 'IMonitor Features - Digital Inspection Tools & Capabilities' } },
    { path: 'industries', component: IndustriesComponent, data: { title: 'Industries We Serve - IMonitor Solutions' } },
    { path: 'pricing', component: PricingComponent, data: { title: 'IMonitor Pricing - Plans & Packages' } },
    // Legacy URL redirects with 301
    { path: 'features', redirectTo: 'feauters', pathMatch: 'full' },
    { path: 'about-us', redirectTo: 'about', pathMatch: 'full' },
    { path: 'faqs', redirectTo: 'faq', pathMatch: 'full' },
    // Catch all route for 404
    { path: '**', component: NotFoundComponent, data: { title: '404 Not Found - IMonitor' } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }